import { Box, Typography, Switch } from "@mui/material";

import { GroupingBox } from "components/utility/GroupingBox";

import { i18n } from "services/i18nService";

export function CalculateDueDateSwitch(props) {
  const { onValueChange, value } = props;

  return (
    <GroupingBox heading={i18n("frmLabel.AccountingBillDueDateCalculation")}>
      <Box sx={{ display: "flex", gap: 2, pl: 1, pr: 1, pt: 0.3 }}>
        <Typography component="span">
          {i18n("frmLabel.BasedOnItemReceiptDate")}
        </Typography>
        <Switch
          size="small"
          checked={value}
          onChange={(e) =>
            onValueChange("calculateDueDateFromInvoiceDate", e.target.checked)
          }
        />
        <Typography component="span">
          {i18n("frmLabel.BasedOnEnteredInvoiceDate")}
        </Typography>
      </Box>
    </GroupingBox>
  );
}
